import React, { useEffect, useState } from 'react'
import ReactMarkdown from 'react-markdown'
import { Environment } from 'environment.js'
import type { BaseModalProps } from '../Modal/BaseModal.js'
import { BaseModal } from '../Modal/BaseModal.js'

export const VersionWidget = (props: BaseModalProps) => {
  const [changelogMd, setChangelogMd] = useState<string | null>(null)

  const currentEnv = Environment.SENTRY_RELEASE_VERSION?.toLowerCase().includes('prod') ? 'prod' : 'staging'
  const changelogPath = `/CHANGELOG.${currentEnv}.md`

  useEffect(() => {
    fetch(changelogPath)
      .then((res) => {
        if (!res.ok) throw new Error(`Changelog not found: ${changelogPath}`)
        return res.text()
      })
      .then(setChangelogMd)
      .catch((err) => {
        console.warn(`Falling back to staging changelog: ${err.message}`)
        return fetch('/CHANGELOG.staging.md')
          .then((res) => res.text())
          .then(setChangelogMd)
      })
  }, [])

  return (
    <BaseModal isOpen={props.isOpen} onClose={props.onClose}>
      <div className="modal-box w-full max-w-3xl max-h-[90vh] flex flex-col p-0">
        <div className="px-6 pt-6 pb-2 border-b">
          <h3 className="text-lg text-center font-bold">Spcfy Changelog</h3>
        </div>

        <div className="overflow-y-auto px-6 py-4 grow prose max-w-none">
          {changelogMd ? <ReactMarkdown>{changelogMd}</ReactMarkdown> : <p className="text-sm text-gray-500">Loading changelog...</p>}
        </div>

        <div className="modal-action border-t px-6 py-4">
          <button className="btn btn-primary" onClick={() => props.onClose()}>
            Close
          </button>
        </div>
      </div>
    </BaseModal>
  )
}
